import axios from 'axios';
import dataApi from '../dataApi';

const MULTIPART = {
  'content-type': 'multipart/form-data'
};

const JSON = {
  'content-type': 'application/json'
};

class HttpNirServiceApi {
  constructor(baseURL = process.env.REACT_APP_NIR_API_URL) {
    this.baseURL = baseURL;
    this.isGlobal = false;

    this.httpClient = axios.create({
      baseURL,
      headers: {
        'X-Frame-Options': 'deny'
      }
    });
  }

  setAuthToken = token => {
    this.httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  };

  removeAuthToken = () => {
    this.httpClient.defaults.headers.common.Authorization = undefined;
  };

  uploadBomReport = formData => {
    return this.httpClient.put(`/bom/${dataApi.getOrganization()}`, formData, {
      headers: MULTIPART
    });
  };

  setPpsiGlobal = (globalPiaArticleNumber, newPpsiId) => {
    return this.httpClient.put(
      `/ppsi/${dataApi.getOrganization()}/${newPpsiId}/${globalPiaArticleNumber}/setGlobal`,
      { headers: JSON }
    );
  };

  revertToMarketDish = formulaCodes => {
    return this.httpClient.put(
      `/ppsi/${dataApi.getOrganization()}/revertGlobal`,
      {
        itemsToMarketRequest: formulaCodes
      },
      {
        headers: JSON
      }
    );
  };

  saveProductArea = (ppsiId, productAreaData) => {
    return this.httpClient.patch(
      `/product-area/${dataApi.getOrganization()}/${ppsiId}`,
      productAreaData,
      {
        headers: JSON
      }
    );
  };

  publishProductArea = ppsiId => {
    return this.httpClient.patch(
      `/product-area/all/${dataApi.getOrganization()}/${ppsiId}`,
      {
        headers: JSON
      }
    );
  };

  getProductArea = () => {
    return this.httpClient.get(`/product-area/all`, {
      headers: JSON
    });
  };
}

export default HttpNirServiceApi;
